import { catalog } from '@littlebird/action-cards-view';
import { defineRegistry } from '@littlebird/action-cards-view/react';

import { AddFields } from './components/AddFields';
import { Attachment } from './components/Attachment';
import { Badge } from './components/Badge';
import { Body } from './components/Body';
import { Button } from './components/Button';
import { CalendarSnapshot } from './components/CalendarSnapshot';
import { Change } from './components/Change';
import { Checkbox } from './components/Checkbox';
import { CheckList } from './components/CheckList';
import { Chip } from './components/Chip';
import { ChipList } from './components/ChipList';
import { Collapsible } from './components/Collapsible';
import { Column } from './components/Column';
import { DateInput } from './components/DateInput';
import { DateRange } from './components/DateRange';
import { Divider } from './components/Divider';
import { Heading } from './components/Heading';
import { Icon } from './components/Icon';
import { Image } from './components/Image';
import { Label } from './components/Label';
import { Link } from './components/Link';
import { Message } from './components/Message';
import { Note } from './components/Note';
import { OptionList } from './components/OptionList';
import { Paragraph } from './components/Paragraph';
import { Person } from './components/Person';
import { ProviderIcon } from './components/ProviderIcon';
import { Reaction } from './components/Reaction';
import { Reason } from './components/Reason';
import { Recipients } from './components/Recipients';
import { Row } from './components/Row';
import { ScreenshotImage } from './components/ScreenshotImage';
import { Select } from './components/Select';
import { StatusLine } from './components/StatusLine';
import { Steps } from './components/Steps';
import { TaskRow } from './components/TaskRow';
import { TextArea } from './components/TextArea';
import { TextInput } from './components/TextInput';
import { Urgency } from './components/Urgency';
import './cardScale.css';

// json-render requires a handler per catalog action, but CardRenderer mounts its own
// handlers and presses never reach these; one would mean a card rendered outside it
const unreachable = async () => {
  console.warn(
    '[ACTION_CARDS] a press reached the registry outside CardRenderer'
  );
};

// navigate has no handler anywhere, and restore has one only when the host
// gives it: dispatchCardAction refuses an unhandled one as `unhandled_action` before a
// press ever reaches CardRenderer's own handlers
function notHandledYet(action: string) {
  return async () => {
    console.warn('[ACTION_CARDS] action not handled yet', { action });
  };
}

export const webRegistry = defineRegistry(catalog, {
  components: {
    Column,
    Row,
    Heading,
    Paragraph,
    Label,
    Badge,
    Chip,
    Divider,
    TextInput,
    TextArea,
    Select,
    Checkbox,
    ChipList,
    CheckList,
    Button,
    Link,
    Note,
    ProviderIcon,
    Image,
    Person,
    Attachment,
    DateRange,
    Body,
    Icon,
    Urgency,
    Message,
    Change,
    DateInput,
    Collapsible,
    TaskRow,
    Steps,
    Reaction,
    StatusLine,
    Reason,
    Recipients,
    AddFields,
    OptionList,
    CalendarSnapshot,
    ScreenshotImage,
  },
  actions: {
    run: unreachable,
    dismiss: unreachable,
    acknowledge: unreachable,
    open: unreachable,
    chat: unreachable,
    navigate: notHandledYet('navigate'),
    restore: notHandledYet('restore'),
  },
});
